export function canAccessShop(user) {
  return user?.ruolo === "admin" || user?.ruolo === "superadmin" || !!user?.is_super;
}
